import { inject } from 'vue'
import { useI18n } from 'vue-i18n'

export default function useApi() {
  const { locale, t } = useI18n()
  const getJSON = inject('getJSON')
  const postJSON = inject('postJSON')
  const putJSON = inject('putJSON')
  const patchJSON = inject('patchJSON')
  const deleteJSON = inject('deleteJSON')
  const getFile = inject('getFile')

  async function downloadFile(location, name, delegateErrorHandling = false) {
    try {
      const fileContent = await getFile(location)

      const dataUrl = window.URL.createObjectURL(fileContent)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = dataUrl

      a.download = name
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(dataUrl)
    } catch (error) {
      if (!delegateErrorHandling) {
        alert(t('document.downloadError'))
      } else {
        throw error
      }
    }
  }

  return {
    getJSON,
    postJSON,
    putJSON,
    patchJSON,
    deleteJSON,
    getFile,
    downloadFile,
    locale,
  }
}
